export default [
  {
    description: 'Floating Bug Tab GECX',
    control: '2880-20',
    treatment: '2880-21',
    ks: 'aiFloatingActionButtonEnabled',
    devices: ['Desktop', 'Mobile'],
    invalidationPrefetch: false,
    clientSide: true,
  },
  {
    description: 'trending queries (popular searches)',
    control: '2565-20',
    treatment: '2565-21',
    ks: 'popularSearchesEnabled',
    arm: 'popularSearchesArm1',
    devices: ['Mobile'],
    invalidationPrefetch: false,
    clientSide: true,
  },
  {
    description: 'trending queries (popular searches)',
    control: '2565-20',
    treatment: '2565-22',
    ks: 'popularSearchesEnabled',
    arm: 'popularSearchesArm2',
    devices: ['Mobile'],
    invalidationPrefetch: false,
    clientSide: true,
  },
  {
    description: 'MEW whitespace removal',
    control: '3089-20',
    treatment: '3089-21',
    ks: 'mewWhitespaceRemovalEnabled',
    devices: ['Mobile'],
    invalidationPrefetch: false,
  },
  {
    description: 'Enabled Gray Search Bar Prominence',
    control: '3244-20',
    treatment: '3244-21',
    ks: 'graySearchBarProminenceEnabled',
    devices: ['Desktop', 'Mobile'],
    invalidationPrefetch: false,
  },
  {
    description: 'Ask Macys Prompts',
    control: '3233-20',
    treatment: '3233-21',
    ks: 'askMacysPromptsEnabled',
    arm: 'askMacysPromptsArmOne',
    devices: ['Desktop', 'Mobile'],
    invalidationPrefetch: false,
    clientSide: true,
  },
  {
    description: 'Ask Macys Prompts',
    control: '3233-20',
    treatment: '3233-22',
    ks: 'askMacysPromptsEnabled',
    arm: 'askMacysPromptsArmTwo',
    devices: ['Desktop', 'Mobile'],
    invalidationPrefetch: false,
    clientSide: true,
  },
];
